import { LyfeAvatar as Avatar, LyfeTypographyTypes } from "@lyfegen-platform/react-common";
import { TypographyProps } from "@material-ui/core";
import { GET_PROFILE_PICTURE } from "../containers/user/queries";
import { useDataQuery } from "../hooks/useDataModule";
import LyfegenBadge from "./icons/LyfegenBadge";

interface StyleProps {
	style?: React.CSSProperties;
	className?: string;
}
interface LyfeAvatarProps {
	isSystemAvatar?: boolean;
	userId?: string;
	userEmail?: string;
	firstName?: string;
	lastName?: string;
	currentUser?: boolean;
	tooltipProps?: StyleProps & { open?: boolean };
	avatarProps?: StyleProps;
	hideTooltip?: boolean;
	toolTipTitle?: string;
	avatarStyle?: React.CSSProperties;
	onClick?: () => void;
	initialsProps?: TypographyProps & LyfeTypographyTypes;
	size?: SizeOptions;
	iconButtonProps?: {
		cursor?: string;
		disableRipple?: boolean;
	};
	isInsideButton?: boolean;
	hasBadge?: boolean;
	badgeColor?: string;
	avatarSrc?: string;
}

type SizeOptions = "XSmall" | "small" | "medium" | "large";

const LyfeAvatar: React.FC<LyfeAvatarProps> = ({ userId, userEmail, avatarSrc, isSystemAvatar, ...otherProps }) => {
	const { data } = useDataQuery(GET_PROFILE_PICTURE, {
		variables: { id: userId, email: userEmail },
		fetchPolicy: "cache-first",
		skip: true,//(!userId && !userEmail) || !!avatarSrc || isSystemAvatar === true,
	});

	const getSource = () => {
		if (isSystemAvatar || otherProps.children) return undefined;
		return avatarSrc ? avatarSrc : data?.GetUserProfilePicture.editedUserPicture;
	};

	return (
		<Avatar src={getSource()} {...otherProps}>
			{isSystemAvatar ? <LyfegenBadge /> : undefined}
		</Avatar>
	);
};

export default LyfeAvatar;
